(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/assets/javascripts/views/gaming-info/gaming-info.js') >= 0) return;  svs.modules.push('/modules/player-login/assets/javascripts/views/gaming-info/gaming-info.js');

'use strict';

svs.player_login.views.GamingInfo = Marionette.View.extend({
  template() {
    this.getTemplate();
  },
  regions: {
    gamingLimits: '#gaming-limits',
    gamingHistory: '#gaming-history'
  },
  ui: {
    gamingLimits: 'li[data-tab="gaming-limits"]',
    gamingHistory: 'li[data-tab="gaming-history"]',
    gamingInfo: 'li[data-tab="last-login-time"]'
  },
  events: {
    'click @ui.gamingLimits': 'clickGamingLimits',
    'click @ui.gamingHistory': 'clickGamingHistory',
    'click @ui.gamingInfo': 'clickGamingInfo',
    'keydown @ui.gamingLimits': 'clickGamingLimits',
    'keydown @ui.gamingHistory': 'clickGamingHistory',
    'keydown @ui.gamingInfo': 'clickGamingInfo'
  },
  behaviors: [svs.player_login.behaviors.Navigation],
  getTemplate() {
    this.model.set('firstNameLogin', "".concat(this.model.get('firstNameLogin') || svs.core.userSession.getUser().firstName));
    if (this.model.get('isPnp')) {
      return svs.player_login.templates.gaming_info_pnp;
    }
    return svs.player_login.templates.gaming_info;
  },
  onAttach() {
    svs.currentGamingInfo = this;
    this.setPnpUrl();
    window.scrollTo(0, 0);
    this.clickGamingInfo();
  },
  getQueryString() {
    const returnUrl = svs.utils.url.queryString.returnUrl;
    let queryString = '?';
    const keys = Object.keys(svs.utils.url.queryString);
    keys.forEach((e, i) => {
      if (e === 'returnUrl') {
        return;
      }
      queryString += "".concat(i === 0 ? '' : '&').concat(e, "=").concat(encodeURIComponent(svs.utils.url.queryString[e]));
    });
    queryString = queryString === '?' ? '' : queryString;
    svs.player_login.data.login.pnpContinueUrl = "".concat(returnUrl).concat(queryString);
  },
  setPnpUrl() {
    if (this.model.get('isPnp') && this.model.get('hasDepositAndTimeLimitsSet')) {
      var _svs$components$Stora;
      const continueButtons = document.querySelectorAll('.js-login-navigation-pnp');
      const hasDepositAmount = (_svs$components$Stora = svs.components.Storage) === null || _svs$components$Stora === void 0 || (_svs$components$Stora = _svs$components$Stora.browser) === null || _svs$components$Stora === void 0 || (_svs$components$Stora = _svs$components$Stora.get('depositValues', 'quick-deposit')) === null || _svs$components$Stora === void 0 ? void 0 : _svs$components$Stora.amount;
      const returnUrl = svs.utils.url.queryString.returnUrl;
      if (hasDepositAmount !== undefined) {
        svs.player_login.data.login.pnpContinueUrl = "".concat(svs.core.urlMapping.get('quickDeposit')).concat(svs.utils.url.getLocation().search);
      } else if (returnUrl !== undefined) {
        this.getQueryString();
      } else {
        svs.player_login.data.login.pnpContinueUrl = "".concat(svs.core.urlMapping.get('pnpHome')).concat(svs.utils.url.getLocation().search);
      }
      continueButtons.forEach(e => {
        e.href = svs.player_login.data.login.pnpContinueUrl;
      });
    }
  },
  instantiateChildView(target) {
    if (this[target]) {
      return;
    }
    switch (target) {
      case 'gamingLimits':
        this.gamingLimits = new svs.player_login.views.GamingLimits({
          el: '#gaming-limits > section',
          returnUrl: this.model.get('returnUrl'),
          isPnp: this.model.get('isPnp'),
          pnpContinueUrl: svs.player_login.data.login.pnpContinueUrl
        });
        this.showChildView('gamingLimits', this.gamingLimits);
        break;
      case 'gamingHistory':
        this.gamingHistory = new svs.player_login.views.GamingHistory({
          el: '#gaming-history > section',
          returnUrl: this.model.get('returnUrl'),
          isPnp: this.model.get('isPnp'),
          pnpContinueUrl: svs.player_login.data.login.pnpContinueUrl
        });
        this.showChildView('gamingHistory', this.gamingHistory);
        break;
      default:
    }
  },
  toggleActive(target) {
    const tabSelectors = document.querySelector('.tab.tab-tabs').children;
    const tabDisplayAreas = document.querySelector('.tab-content').children;
    Array.from(tabSelectors).forEach(e => (e === null || e === void 0 ? void 0 : e.getAttribute('data-tab')) === target ? e === null || e === void 0 ? void 0 : e.classList.add('active') : e === null || e === void 0 ? void 0 : e.classList.remove('active'));
    Array.from(tabDisplayAreas).forEach(e => (e === null || e === void 0 ? void 0 : e.id) === target ? e === null || e === void 0 ? void 0 : e.classList.add('active') : e === null || e === void 0 ? void 0 : e.classList.remove('active'));
  },
  shouldIgnoreClickEvent(event) {
    if (event === undefined || event.originalEvent.key !== 'Enter' && event.type === 'keydown') {
      return true;
    }
    return false;
  },
  clickGamingInfo(event) {
    if (this.shouldIgnoreClickEvent(event)) {
      return;
    }
    this.toggleActive('last-login-time');
    svs.components.analytics.trackEvent({
      action: 'översikt',
      category: 'login-info',
      opt_label: 'inloggning'
    });
  },
  clickGamingLimits(event) {
    if (this.shouldIgnoreClickEvent(event)) {
      return;
    }
    this.instantiateChildView('gamingLimits');
    this.toggleActive('gaming-limits');
    svs.components.analytics.trackEvent({
      action: 'spelkoll',
      category: 'login-info',
      opt_label: 'gränser'
    });
  },
  clickGamingHistory(event) {
    if (this.shouldIgnoreClickEvent(event)) {
      return;
    }
    this.instantiateChildView('gamingHistory');
    this.toggleActive('gaming-history');
    svs.components.analytics.trackEvent({
      action: 'spelhistorik',
      category: 'login-info',
      opt_label: 'historik'
    });
  }
});

 })(window);